// filepath: path/to/your/controller.js
import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    // Show CTA bar after 1 second
    setTimeout(() => {
      this.element.classList.add("cta-bar--show");
    }, 2000);

    this.checkVisibility();
    document.addEventListener("scroll", () => this.checkVisibility());
  }

  disconnect() {
    document.removeEventListener("scroll", () => this.checkVisibility());
  }

  closeModal(e) {
    e.preventDefault();
    this.element.remove()
  }

  checkVisibility() {
    const showOffset = 0;

    if (window.pageYOffset > showOffset) {
      this.element.classList.add("cta-bar--show");
    } else {
      this.element.classList.remove("cta-bar--show");
    }
  }
}
